export interface RetryWithDelaysOptions {
  retryDelays: readonly number[];
  pause?: (delayMs: number) => Promise<void>;
  shouldRetry?: (error: unknown) => boolean;
}

function wait(delayMs: number): Promise<void> {
  return new Promise(resolve => window.setTimeout(resolve, delayMs));
}

export async function retryWithDelays<T>(
  operation: () => Promise<T>,
  { retryDelays, pause = wait, shouldRetry = () => true }: RetryWithDelaysOptions
): Promise<T> {
  for (let attempt = 0; ; attempt += 1) {
    try {
      return await operation();
    } catch (error) {
      const delay = retryDelays[attempt];
      if (delay === undefined || !shouldRetry(error)) throw error;
      await pause(delay);
    }
  }
}
